/*
 * @Author: handan05
 * @Date: 2022-07-28 11:21:05
 * @LastEditors: handan05 handan05@58.com
 * @LastEditTime: 2023-12-16 19:55:43
 * @FilePath: /operation-utils/Users/handan/Documents/handan_work/58work/58project/tech/wblog/src/utils.ts
 * @Description:
 */
import { isObject } from './type';

// 校验是否满足正则要求
export const isSussKey = (key: string) => {
    const reg = /^[0-9a-zA-Z_-]{1,}$/g;
    if (!reg.test(key)) {
        console.log('埋点key必须是数字、字母、-、_');
        return false;
    }
    return true;
};

/**
 * 从所有params中获取上报模式__trackMode并删除对应key
 * __trackMode === undefined : 老代码未指定上报模式, 仅上报无线埋点
 * __trackMode === 1 : 只上报无线埋点
 * __trackMode === 2 : 只上报wmda埋点
 * __trackMode === 3 : 无线埋点 与 wmda埋点均上报
 */
export const getTrackMode = params => {
    const trackMode = params.__trackMode;
    delete params.__trackMode;
    return trackMode;
};

// 是否无线
export const isWx = trackMode => [undefined, 1, 3].indexOf(trackMode) > -1;

// 是否wmda
export const isWmda = trackMode => [2, 3].indexOf(trackMode) > -1;

// 解析函数参数
export const parseParams = (paramsList: any[]) =>
    paramsList.reduce((preV, cur) => (isObject(cur) ? { ...preV, ...cur } : preV), {});

// 函数节流
export const throttle = (func: Function, delay: number) => {
    let timer: any = null;
    return function () {
        if (!timer) {
            timer = setTimeout(() => {
                func();
                timer = null;
            }, delay);
        }
    };
};

export function getAppVersion() {
    let version = '999.999.999';
    const ua = navigator.userAgent;
    const vReg = /(wbutown|WUBA|WBUA)\/(\d+(.\d+){2,})/i;
    const mValue = ua.match(vReg);
    if (mValue != null) {
        version = decodeURIComponent(mValue[2]);
    }
    return version;
}

export function GJgetAppVersion() {
    let version = '999.999.999';
    const ua = navigator.userAgent;
    const vReg = /GANJI\/(\d+(.\d+){2,})/i;
    const mValue = ua.match(vReg);
    if (mValue != null) {
        version = decodeURIComponent(mValue[1]);
    }
    return version;
}

export const getUid = () => {
    /* 用户UID */
    let UID = '';
    try {
        // 获取UID
        UID = document.cookie
            .split(';')
            .filter(item => item.indexOf('PPU=') > -1)[0]
            .split('&')[0]
            .split('=')[2];
    } catch (e) {
        // console.log('埋点监听，获取uid失败')
    }
    return UID;
};
